var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true },
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c("store-review", {
        ref: "storeReview",
        attrs: {
          "store-id": _vm.storeId,
          "can-edit": _vm.action !== "view",
          "is-create": _vm.action === "create",
        },
        on: { create: _vm.changeCreate },
      }),
      _c("div", { staticClass: "app-form-button-height" }),
      _c(
        "div",
        { staticClass: "app-form-button-group" },
        [
          _c(
            "el-button",
            { attrs: { icon: "el-icon-back" }, on: { click: _vm.onBack } },
            [_vm._v("返回列表")]
          ),
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.onCreate } },
            [_vm._v("新增商家")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
            [_vm._v("提交保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }